import React from 'react'
import Popup from './Popup'
import Button, { ButtonStyle } from './Button'

const ButtonsPopup: React.FC<{
  children: React.ReactNode
  title?: string
  orientation: 'stack' | 'row'
  actions: { style: ButtonStyle, label: string, onClick: () => void }[]
}> = (props) => {
  return (
    <Popup onClose={() => { return }}>
      {props.title && (
        <div className="title">
          {props.title}
        </div>
      )}

      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
        {props.children}
      </div>

      <div className={props.orientation === 'stack' ? 'buttonStack' : 'buttonRow'}>
        {props.actions.map(action => (
          <Button key={action.label} onClick={action.onClick} buttonStyle={action.style}>
            {action.label}
          </Button>
        ))}
      </div>
    </Popup>
  )
}

export default ButtonsPopup
